import { ButtonEnum } from "@xlabmedical/medic-web-framework";
import { PatientListModel } from "@/models/PatientListModel";

export function ChangeBackground() {
    document.getElementById("div-body")?.classList.remove("bg-body-wiz");
    document.getElementById("div-body")?.classList.add("bg-body");
    document.getElementsByClassName("pi-user-edit")[0]?.classList.add("ml-1");
    document.getElementsByClassName("pi-user-edit")[0]?.classList.add("-mr-1");
}

export const getVisibleIconCount = (patient: PatientListModel) => {
    let count = 1; // fixed cloud icon

    // Each <img> or <RgPatientListIconBadge> condition
    if (!patient.hasAccess) count++; // warning icon
    if (patient.foreignOwner || patient.shares?.length) count++; // shared icon
    if (patient.projectUnreadNotificationsPerChannel) count++; // project badge
    if (patient.hasWeblinkOrder) count++; // order badge

    return count;
};

export const formatPatientBirthDate = (date?: Date | string) => {
    if (!date) {
        return "";
    }

    const validDate = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(validDate.getTime())) {
        return "";
    }

    // DOB is a calendar date; format in UTC to prevent timezone day shifts.
    return new Intl.DateTimeFormat(undefined, {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        timeZone: "UTC",
    }).format(validDate);
};
